export const tablesHeaders = {
  customers: ['_id', 'createdAt', 'belongsTo', 'documentNumber', 'registeredFullName', 'bankAccountsData', 'documentType', 'modifiedAt'],
  documents: [
    '_id',
    'status',
    'createdAt',
    'belongsTo',
    'uploadedBy',
    'approvedBy',
    'approvedAt',
    'originalName',
    'fileSystemName',
    'errorDescription',
    'totalOfRegistries',
    'cobrePaymentReference',
    'totalOfNoveltiesRejected',
    'totalOfNoveltiesReviewed',
    'totalOfNoveltiesEmptyBankName',
    'totalOfNoveltiesUnknownBankName',
    'totalOfNoveltiesWrongDocumentType',
    'totalOfNoveltiesEmptyPaymentAmount',
    'totalOfNoveltiesWrongPaymentAmount',
    'totalOfNoveltiesBackgroundResearch',
    'totalOfNoveltiesEmptyRegisteredName',
    'totalOfNoveltiesEmptyDocumentNumber',
    'totalOfNoveltiesWrongDocumentNumber',
    'totalOfNoveltiesEmptyBankAccountType',
    'totalOfNoveltiesWrongBankAccountType',
    'totalOfNoveltiesEmptyPaymentReference',
    'totalOfNoveltiesEmptyBankAccountNumber',
    'totalOfNoveltiesWrongBankAccountNumber',
    'totalOfNoveltiesDuplicatePaymentReference',
    'totalOfNoveltiesDuplicateBankAccountNumber',
    'totalOfNoveltiesBankAccountNumberNotRegistered'
  ],
  payments: [
    '_id',
    'status',
    'amount',
    'paidAt',
    'bankName',
    'createdAt',
    'novelties',
    'customerId',
    'documentId',
    'bankAccountType',
    'referenceNumber',
    'bankAccountNumber',
    'bankAccountStatus',
    'backgroundReviewed',
    'cobrePaymentReference',
    'unidentifiedCustomerId',
    'customerRegisteredFullName'
  ],
  'system-users': ['_id', 'createdAt', 'username', 'role', 'firstName', 'lastName', 'activated', 'description'],
  'customer-companies': ['_id', 'preferredLanguage', 'businessOwner', 'businessCompany', 'businessOwnerDocumentation', 'businessCompanyDocumentation', 'balance', 'activated', 'createdAt'],
  'customer-company-fundings': [
    '_id',
    'status',
    'createdAt',
    'createdBy',
    'assignedBy',
    'rejectedBy',
    'assignedTo',
    'expectedProfit',
    'saleTradeResult',
    'fundingSaleRate',
    'purchaseTradeResult',
    'fundingPurchaseRate',
    'fundingSaleQuantity',
    'expectedProfitCurrency',
    'fundingPurchaseQuantity',
    'negotiationType',
    'description',
    'negotiationAdditionalPercentage'
  ]
}
